export default {
  init() {
    // JavaScript to be fired on the home page
    this.initProductCarosel()
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init function


  },

  initProductCarosel() {
    
    const productGrids = document.querySelectorAll(".products-grid"); // Seleziona tutti i caroselli

    productGrids.forEach(function(productGrid) {
        const firstProduct = productGrid.querySelector("li"); // Seleziona il primo prodotto
        if (firstProduct) {
            // Calcola metà della larghezza del primo prodotto
            const halfProductWidth = firstProduct.offsetWidth / 2;
            // Imposta la posizione della scrollbar a metà prodotto
            productGrid.scrollLeft = halfProductWidth;
        }
    });

  },
};
